export default "__VITE_ASSET__BIEXKz87__"